import '../sass/platformdrentsemusea.scss';
import './fix_calendar';
import './jquery_global';
import './mixin_base.js';

// console.log('Assets of Platform Drentse Musea')
